export const CO7_MEMBER_ROLES = {
    OWNER: 'owner',
    EDITOR: 'editor',
    VIEWER: 'viewer',
}

export const CO7_INVITE_ROLES = [
    {
        value: CO7_MEMBER_ROLES.EDITOR,
        label: 'Editor',
        description: 'Can edit collection content',
    },
    {
        value: CO7_MEMBER_ROLES.VIEWER,
        label: 'Viewer',
        description: 'Can view collection only',
    },
]

export const CO7_ROLE_LABELS = {
    [CO7_MEMBER_ROLES.OWNER]: 'Owner',
    [CO7_MEMBER_ROLES.EDITOR]: 'Editor',
    [CO7_MEMBER_ROLES.VIEWER]: 'Viewer',
}

export const CO7_STATUS_LABELS = {
    active: 'Active',
    archived: 'Archived',
}

export const CO7_DEFAULT_LIST_LIMIT = 20

export const canManageCo7Collection = (effectiveRole, isSuperAdmin) =>
    effectiveRole === CO7_MEMBER_ROLES.OWNER || Boolean(isSuperAdmin)

export const isCo7CollectionArchived = (collection) =>
    Boolean(collection?.isDeleted)

/** Owner/super-admin actions on a non-archived collection (edit, invite, member changes). */
export const canEditCo7Collection = (collection, isSuperAdmin) =>
    canManageCo7Collection(collection?.effectiveRole, isSuperAdmin) &&
    !isCo7CollectionArchived(collection)
